import React, { Fragment, useState } from 'react';
import { Col, Form } from 'react-bootstrap';

function TrapMonitoringRecordsForm({
  handleSubmit,
  handleChange,
  handleBlur,
  values,
  errors,
  setFieldValue,
  isSubmitting,
  setFieldTouched
}) {
  const [recordCapsBases, setRecordCapsBases] = useState({
    allCaps: false,
    allBases: false
  });

  return (
    <Form>
      <Form.Group controlId='visited_date'>
        <Form.Label>Date</Form.Label>
        <Form.Control
          type='date'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.visited_date}
          isInvalid={errors.visited_date}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.visited_date}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='operator'>
        <Form.Label>Operator</Form.Label>
        <Form.Control
          type='text'
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.operator}
          placeholder='Operator'
          isInvalid={errors.operator}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.operator}
        </Form.Control.Feedback>
      </Form.Group>
      {values.trapMonitoringRecords?.length > 0 && (
        <Form.Row className='text-center'>
          <Col>
            <Form.Check
              className='float-right'
              custom
              checked={recordCapsBases.allCaps}
              type='checkbox'
              id={`all-caps`}
              label='All Caps'
              onChange={() => {
                values.trapMonitoringRecords.forEach((_, i) => {
                  setFieldValue(
                    `trapMonitoringRecords.${i}.lure_changed`,
                    !recordCapsBases.allCaps
                  );
                  setRecordCapsBases({
                    ...recordCapsBases,
                    allCaps: !recordCapsBases.allCaps
                  });
                });
              }}
            />
          </Col>
          <Col>
            <Form.Check
              className='float-left'
              custom
              checked={recordCapsBases.allBases}
              type='checkbox'
              id={`all-bases`}
              label='All Bases'
              onChange={() => {
                values.trapMonitoringRecords.forEach((_, i) => {
                  setFieldValue(
                    `trapMonitoringRecords.${i}.base_changed`,
                    !recordCapsBases.allBases
                  );
                  setRecordCapsBases({
                    ...recordCapsBases,
                    allBases: !recordCapsBases.allBases
                  });
                });
              }}
            />
          </Col>
        </Form.Row>
      )}
      {values.trapMonitoringRecords.map((record, i) => (
        <Fragment key={i}>
          <hr className='my-1' />
          <Form.Row>
            <h5>
              {record.trap.name} ({record.trap.code})
            </h5>
          </Form.Row>
          <Form.Row>
            <Form.Group
              as={Col}
              xs={4}
              className='d-flex align-items-center'
              controlId='value'
            >
              <div>
                <Form.Label>Catch</Form.Label>
                <Form.Control
                  type='number'
                  min='0'
                  step='1'
                  name={`trapMonitoringRecords.${i}.amount`}
                  value={record.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.trapMonitoringRecords &&
                    errors.trapMonitoringRecords[record.trap.id]
                      ? errors.trapMonitoringRecords[record.trap.id].amount
                      : false
                  }
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.trapMonitoringRecords &&
                  errors.trapMonitoringRecords[record.trap.id]
                    ? errors.trapMonitoringRecords[record.trap.id].amount
                    : null}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            <Form.Group
              as={Col}
              xs={8}
              sm={4}
              className='d-flex flex-column justify-content-center align-items-start'
            >
              <Form.Check
                custom
                checked={record.lure_changed}
                type='checkbox'
                id={`${i}-lure-changed`}
                label='Cap changed'
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFieldValue(
                    `trapMonitoringRecords.${i}.lure_changed`,
                    checked
                  );
                  if (!checked)
                    setRecordCapsBases({ ...recordCapsBases, allCaps: false });
                }}
              />
              <Form.Check
                custom
                checked={record.base_changed}
                type='checkbox'
                id={`${i}-base-changed`}
                label='Based changed'
                onChange={(e) => {
                  const checked = e.target.checked;
                  setFieldValue(
                    `trapMonitoringRecords.${i}.base_changed`,
                    checked
                  );
                  if (!checked)
                    setRecordCapsBases({ ...recordCapsBases, allBases: false });
                }}
              />
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              sm={4}
              className='d-flex flex-column justify-content-center align-items-start'
            >
              <Form.Control
                as='textarea'
                name={`trapMonitoringRecords.${i}.comments`}
                placeholder='Comments'
                value={record.comments}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={
                  errors.trapMonitoringRecords &&
                  errors.trapMonitoringRecords[record.trap.id]
                    ? errors.trapMonitoringRecords[record.trap.id].comments
                    : false
                }
              />
              <Form.Control.Feedback type='invalid'>
                {errors.trapMonitoringRecords &&
                errors.trapMonitoringRecords[record.trap.id]
                  ? errors.trapMonitoringRecords[record.trap.id].comments
                  : null}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
        </Fragment>
      ))}
    </Form>
  );
}

export default TrapMonitoringRecordsForm;
